import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { SingleFieldTypes } from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-cxone-reporting-set-conditional-field",
    templateUrl: "./cxone-reporting-set-conditional-field.component.html",
    styleUrls: ["./cxone-reporting-set-conditional-field.component.scss"],
})
export class CxoneReportingSetConditionalFieldComponent implements OnInit, OnDestroy {
    @Output() back = new EventEmitter();
    @Output() addChilds = new EventEmitter();
    @Output() editExistItem = new EventEmitter();
    @Output() formChanged = new EventEmitter();

    public _parentData: any;
    public isComonFieldVisible = true;
    public operatorPlaceholderText = "";
    public showFields = true;
    public conditionalFieldForm: FormGroup;
    public unsubscribeSubject: any;
    public comparisonForm: any;
    public operatorTypes = [{ label: "-" }, { label: "AND" }, { label: "OR" }];
    @ViewChild('internalBack') internalBack!: ElementRef;
    @ViewChild('conditonBasicForm') conditonBasicForm!: ElementRef;
    @ViewChild('comparisonFormRef') comparisonFormRef!: ElementRef;
    constructor(private cvLocalizationService: CVLocalizationService) {
        this.conditionalFieldForm = new FormGroup({
            operatorDropdown: new FormControl({ value: { label: "-" }, disabled: false })
        });
    }

    @Input() set parentData(data) {
        this._parentData = data;
        const operatorDropdown = data?.operatorDropdown || { label: "-" };
        if (this.conditionalFieldForm) {
            this.conditionalFieldForm.controls["operatorDropdown"].patchValue(operatorDropdown);
            this._parentData.isValid = this.checkIsValid();
        }
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.unsubscribeSubject = this.conditionalFieldForm.valueChanges.subscribe(
            (res) => {
                if (this._parentData) {
                    this._parentData.operatorDropdown = res?.operatorDropdown;
                }
            }
        );
        if (this.parentData) {
            this.parentData.isValid = this.checkIsValid();
        }
    }

    ngOnDestroy() {
        this.unsubscribeSubject.unsubscribe();
        this.showHideDefaultForm(null, null, false);
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        } finally {
            this.operatorPlaceholderText = this.getLocalizationString(
                "Select_Operator",
                "Select Operator"
            );
        }
    }

    getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "ETL_Reporting_Set",
            key,
            defaultValue
        );
        return baseString;
    }

    addInput() {
        this.showFields = false;
        this.addChilds.emit(this.parentData);
    }

    editInput(item) {
        this.editExistItem.emit(item);
    }

    goBack(): void {
        this.back.emit(this.parentData);
    }

    addNewFieldFormComparison(operand, defaultForm, conditionForm) {
        this.showHideDefaultForm(defaultForm, conditionForm, false);
        this._parentData.operand = operand;
        this.comparisonForm[operand] = [];
        this._parentData.comparisonForm = this.comparisonForm;
        this.addChilds.emit(this._parentData);
    }

    addNewField(operand): void {
        this._parentData.operand = operand;
        this._parentData[operand] = [];
        this.addChilds.emit(this._parentData);
    }

    comparisionClick(defaultForm, conditionForm) {
        if (!this._parentData.hasOwnProperty('comparisons')) {
            this._parentData.comparisons = [];
        }
        this._parentData.comparisons.push({ comparisonType: '', field1: [], field2: [] });
        this.comparisonForm = this._parentData.comparisons[this._parentData.comparisons.length - 1];
        this.showHideDefaultForm(defaultForm, conditionForm, true);
    }

    editExistFromDataField(item) {
        this.editExist(item, this.conditonBasicForm?.nativeElement, this.comparisonFormRef?.nativeElement);
    }

    editExist(item, defaultForm, conditionForm) {
        this.comparisonForm = item;
        this.showHideDefaultForm(defaultForm, conditionForm, true);
    }

    backBtn(defaultForm, conditionForm) {
        this.showHideDefaultForm(defaultForm, conditionForm, false);
        const lastAddedComparision = this._parentData.comparisons[this._parentData.comparisons.length - 1];
        if (lastAddedComparision.comparisonType === "" && lastAddedComparision.field1.length === 0 && lastAddedComparision.field2.length === 0) {
            this._parentData.comparisons.pop();
        }
    }

    showHideDefaultForm(defaultForm, conditionForm, hideDefaultForm) {
        if (defaultForm) {
            defaultForm.hidden = hideDefaultForm;
        }
        if (conditionForm) {
            conditionForm.hidden = !hideDefaultForm;
        }
        if (document.getElementById('field-dropdown')) {
            document.getElementById('field-dropdown').hidden = hideDefaultForm;
        }
        if (document.getElementById('data-field-back-btn')) {
            document.getElementById('data-field-back-btn').hidden = hideDefaultForm;
        }
    }

    EditFieldFormComparison(item, defaultForm, conditionForm) {
        this.showHideDefaultForm(defaultForm, conditionForm, false);
        this.editExistItem.emit(item);
    }

    checkIsValid() {
        let isValid = true;
        if (!this._parentData.hasOwnProperty('comparisons')) {
            isValid = false;
        }
        for (let a = 0; a < this._parentData?.comparisons?.length; a++) {
            const compareItem = this._parentData?.comparisons[a];
            if (compareItem.comparisonType === "") {
                isValid = false;
                break;
            }
            const singleFieldValues = SingleFieldTypes;
            if (singleFieldValues.includes(compareItem.comparisonType.value)) {
                if (compareItem.field1.length == 0) {
                    isValid = false;
                    break;
                }
            } else {
                if (compareItem.field1.length === 0 || compareItem.field2.length === 0) {
                    isValid = false;
                    break;
                }
            }
        }

        return this.conditionalFieldForm.valid &&
            isValid &&
            (this._parentData?.negative?.length > 0) &&
            (this._parentData?.positive?.length > 0) && this._parentData.hasOwnProperty('operatorDropdown') && Object.keys(this._parentData.operatorDropdown).length > 0;
    }

    hasValidComparison() {
        let isValid = true;
        for (let a = 0; a < this._parentData?.comparisons?.length; a++) {
            const compareItem = this._parentData?.comparisons[a];
            if (compareItem.comparisonType === "") {
                isValid = false;
                break;
            }
            const singleFieldValues = SingleFieldTypes;
            if (singleFieldValues.includes(compareItem.comparisonType.value)) {
                if (compareItem.field1.length == 0) {
                    isValid = false;
                    break;
                }
            } else {
                if (compareItem.field1.length === 0 || compareItem.field2.length === 0) {
                    isValid = false;
                    break;
                }
            }
        }
        return isValid;
    }

    formValueChanged() {
        this._parentData.isValid = this.checkIsValid();
        this.formChanged.emit(this._parentData);
    }
}
